import React from 'react'
import { Link } from 'react-router-dom'


const CareerCard = ({title, subtitle, description, path}) => {
    return (
        <>
            <div className="flex justify-start h-full w-full">
                <div className="bg-gradient-to-r from-[#A6FFCB] via-[#12D8FA] to-[#1FA2FF] rounded-[11px] xs:w-4 md:w-7 cylinder"></div>

                <div className="bg-gradient-to-r from-[#1FA2FF]  via-[#12D8FA]   to-[#A6FFCB]  p-1 rounded-[20px] -ml-2 my-2 w-full h-[80%] content-box">
                    <div className="bg-black rounded-[15px] ">
                        <div className="flex flex-col py-8 px-10 md:gap-8 xs:gap-[15px]">
                            <div className="text-white">
                                <h2 className="font-faustina font-bold md:text-[40px] xs:text-[clamp(24px,5.5vw,40px)]">
                                    {title}
                                </h2>
                            </div>
                            <div className="text-justify text-white md:text-[20px] xs:text-[clamp(16px,2.7vw,20px)]">
                                <p className="font-poppins font-semibold ">
                                 {subtitle}
                                </p>
                                <p className="font-poppins font-base md:pt-[10px] xs:pt-[15px]">
                                    {description}
                                </p>
                            </div>
                            {/* Button */}
                            <div className="md:mt-[8px] xs:mt-[12px] flex justify-center items-center md:w-[155px] xs:w-[140px] md:h-[62px] xs:h-[50px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[14px] bg-transparent p-0.5">
                                <Link to={path} target='_blank' className="button-main bg-black uppercase w-full h-full rounded-[14px] font-poppins font-medium  xs:text-[18px] md:text-[20px] diagonal text-xl text-center relative py-[16px] sm:py-[14px] px-[52px] sm:px-[45px]">
                                    <span className="old-text absolute transition-all top-0 left-0 w-full h-full flex justify-center items-center text-white">
                                        VISIT CAREER
                                    </span>
                                    <span className="new-text absolute ">VISIT CAREER</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CareerCard